import { render, staticRenderFns } from "./ViewFilePartner.vue?vue&type=template&id=2233a449&"
import script from "./ViewFilePartner.vue?vue&type=script&lang=ts&"
export * from "./ViewFilePartner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports